import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MessageComponent } from '@core/user-interface-legacy';

import type { CustomInputComponentInterface } from '../../client/integrations-client.types';

@Component({
  selector: 'rti-error-messages-wrapper',
  templateUrl: './error-messages-wrapper.component.html',
  styleUrls: ['./error-messages-wrapper.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MessageComponent],
})
export class ErrorMessagesWrapperComponent implements CustomInputComponentInterface {
  [k: string]: unknown;
  public readonly errors = input<string[]>([]);

  public trackByErrorMessage(_index: number, error: string): string {
    return error;
  }
}
